'use strict';

var jsxRuntime = require('react/jsx-runtime');

const LargeFilter = ({ testId, className, solid })=>{
    return jsxRuntime.jsx("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: "24",
        height: "24",
        viewBox: "0 0 24 24",
        fill: "none",
        "data-testid": testId,
        className: className,
        children: solid ? jsxRuntime.jsxs(jsxRuntime.Fragment, {
            children: [
                jsxRuntime.jsx("path", {
                    fillRule: "evenodd",
                    clipRule: "evenodd",
                    d: "M11.2998 8.00005C11.2998 6.50888 12.5086 5.30005 13.9998 5.30005C15.491 5.30005 16.6998 6.50888 16.6998 8.00005C16.6998 9.49122 15.491 10.7 13.9998 10.7C12.5086 10.7 11.2998 9.49122 11.2998 8.00005Z",
                    fill: "currentColor"
                }),
                jsxRuntime.jsx("path", {
                    fillRule: "evenodd",
                    clipRule: "evenodd",
                    d: "M20 8.70005L16 8.70005L16 7.30005L20 7.30005L20 8.70005Z",
                    fill: "currentColor"
                }),
                jsxRuntime.jsx("path", {
                    fillRule: "evenodd",
                    clipRule: "evenodd",
                    d: "M12 8.70005H4V7.30005H12V8.70005Z",
                    fill: "currentColor"
                }),
                jsxRuntime.jsx("path", {
                    fillRule: "evenodd",
                    clipRule: "evenodd",
                    d: "M12.7002 16C12.7002 17.4911 11.4914 18.7 10.0002 18.7C8.50903 18.7 7.3002 17.4911 7.3002 16C7.3002 14.5088 8.50903 13.3 10.0002 13.3C11.4914 13.3 12.7002 14.5088 12.7002 16Z",
                    fill: "currentColor"
                }),
                jsxRuntime.jsx("path", {
                    fillRule: "evenodd",
                    clipRule: "evenodd",
                    d: "M4 15.3L8 15.3L8 16.7L4 16.7L4 15.3Z",
                    fill: "currentColor"
                }),
                jsxRuntime.jsx("path", {
                    fillRule: "evenodd",
                    clipRule: "evenodd",
                    d: "M12 15.3L20 15.3L20 16.7L12 16.7L12 15.3Z",
                    fill: "currentColor"
                })
            ]
        }) : jsxRuntime.jsxs(jsxRuntime.Fragment, {
            children: [
                jsxRuntime.jsx("circle", {
                    cx: "14",
                    cy: "8",
                    r: "2",
                    stroke: "currentColor",
                    strokeWidth: "1.4"
                }),
                jsxRuntime.jsx("path", {
                    d: "M16 8L20 8",
                    stroke: "currentColor",
                    strokeWidth: "1.4"
                }),
                jsxRuntime.jsx("path", {
                    d: "M4 8H12",
                    stroke: "currentColor",
                    strokeWidth: "1.4"
                }),
                jsxRuntime.jsx("circle", {
                    cx: "10",
                    cy: "16",
                    r: "2",
                    transform: "rotate(-180 10 16)",
                    stroke: "currentColor",
                    strokeWidth: "1.4"
                }),
                jsxRuntime.jsx("path", {
                    d: "M8 16L4 16",
                    stroke: "currentColor",
                    strokeWidth: "1.4"
                }),
                jsxRuntime.jsx("path", {
                    d: "M20 16L12 16",
                    stroke: "currentColor",
                    strokeWidth: "1.4"
                })
            ]
        })
    });
};

module.exports = LargeFilter;
